import { DraftInterface } from '../../Interfaces/Draft/DraftInterface'
import {
  RecurringActionType,
  RecurringFrequencyType,
  RecurringProfileEventType,
  RecurringProfileInterface,
  RecurringProfileSettingsInterface,
  RecurringProfileStatusEventType,
  RecurringProfileStatusType,
} from '../../Interfaces/RecurringProfileInterface'

export const getDefaultRecurringProfile = (issueDate: string): RecurringProfileSettingsInterface => {
  return {
    frequency: RecurringFrequencyType.MONTHLY,
    confirmation: true,
    repeat: 5,
    action: RecurringActionType.CREATE,
    startDate: issueDate,
    message: {
      attachmentUuids: [],
      body: '',
      to: '',
    },
  }
}

export const getRecurringCustomerName = (recurringProfile: RecurringProfileInterface) => {
  return recurringProfile.draft.receiver.displayName
}

export const isRecurring = (draft: DraftInterface) =>
  draft.fields.recurringProfileEnabled && draft.fields.recurringProfileEnabled.value

export const getOccurrence = (recurringProfile: RecurringProfileInterface) => {
  const currentRepeat = recurringProfile.status.events.filter(
    (obj) => obj.eventType === RecurringProfileEventType.PROFILE_DOCUMENT_CREATED,
  ).length
  return recurringProfile.schedule.repeat !== null
    ? `${currentRepeat}/${recurringProfile.schedule.repeat}`
    : `${currentRepeat}`
}

export const hasCompletedStatus = (recurringProfile: RecurringProfileInterface): boolean => {
  return recurringProfile.status.events.some((e) => e.eventType === RecurringProfileEventType.PROFILE_COMPLETED)
}

export const getEventTypeForStatus = (status: RecurringProfileStatusType): RecurringProfileStatusEventType => {
  switch (status) {
    case RecurringProfileStatusType.ACTIVE:
      return RecurringProfileStatusEventType.STARTED
    case RecurringProfileStatusType.INACTIVE:
      return RecurringProfileStatusEventType.PAUSED
    case RecurringProfileStatusType.COMPLETED:
      return RecurringProfileStatusEventType.COMPLETED
    default:
      return null
  }
}
